import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000/api';

const getToken = () => localStorage.getItem("token");

export const loginAPI = async (credentials) => {
  return axios.post(`${API_BASE_URL}/auth/admin-login`, credentials);
};

export const loginPartnerAPI = async (credentials) => {
  return axios.post(`${API_BASE_URL}/auth/partner-login`, credentials);
};

export const verifyTokenAPI = async () => {
  return axios.get(`${API_BASE_URL}/auth/verify-token`, {
    headers: { token: getToken() },
  });
};
export const logoutAPI = async () => {
  const token = localStorage.getItem("token");
  return axios.post(
    `${API_BASE_URL}/user/admin-logout`,
    {},
    {
      headers: {
        token: token,
      },
    }
  );
};

export const verifyPartnerEmail = async (credentials) => {
  return axios.post(`${API_BASE_URL}/auth/partner-verify-email`, credentials);
};

export const resetPartnerPassword = async (credentials) => {
  return axios.post(`${API_BASE_URL}/auth/partner-reset-password`, credentials);
};

